import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

type HintProps = ComponentPropsWithoutRef<'aside'> & {
  mode?: 'default' | 'small';
};

export const Hint: FC<HintProps> = ({ mode, ...props }) => (
  <aside
    {...props}
    className={cn(
      `
        inline-block
        not-legacy:text-foreground-surface-subdued
        legacy:text-legacy-brand-light-2
      `,
      mode === 'small' &&
        `
          not-legacy:text-body-sm
          legacy:text-legacy-xs
        `
    )}
  />
);
